import { render, staticRenderFns } from "./platformSwiper.vue?vue&type=template&id=30f025e1&"
import script from "./platformSwiper.vue?vue&type=script&lang=js&"
export * from "./platformSwiper.vue?vue&type=script&lang=js&"
import style0 from "./platformSwiper.vue?vue&type=style&index=0&id=30f025e1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports